import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPerformance } from "store/auth/profile/profileSlice";
import { Col, Row, Button } from "reactstrap";
import { PerformanceForm } from "./PerformanceForm";
import { Modal } from "antd";

const Performance = () => {
  const dispatch = useDispatch()
  let performance = useSelector((state) => state.Profile.performance)
  performance = performance?.performances?.[0]
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    dispatch(getPerformance())
  }, [dispatch])
  return (
    <div className="py-4 px-3 px-sm-5 px-md-5 px-lg-5">

      <div className="container
            bg-light
            rounded-3
            shadow-sm
            p-3 p-sm-4 p-md-5
            mx-auto">
        {
          showModal ? (
            <Modal
              title={'Edit profile'}
              open={showModal}
              onCancel={() => setShowModal(false)}
              footer={null}
              width={600}
              styles={{
                body: { minHeight: "400px" } // New way to control height
              }}          >
              <PerformanceForm setShowModal={setShowModal} />
            </Modal>
          ) : null
        }
        <Row className="fs-5 fw-normal p-1 p-sm-2 p-md-2">
          <Col lg={16} className="mx-auto">
            {performance ? (
              <>
                <Row className="gx-3 gx-md-4">
                  <Col xs={12} md={6}>
                    <h2>Trophées remportés</h2>
                    {performance.trophies.length > 0 ? (
                      <ul>
                        {performance.trophies.map((trophy, idx) => (
                          <li key={idx}>{trophy}</li>
                        ))}
                      </ul>
                    ) : (
                      <p>Aucun trophée remporté</p>
                    )}
                  </Col>

                  <Col xs={12} md={6}>
                    <h2>Statistiques clés</h2>
                    <p className="mb-2"><strong>Buts marqués :</strong> {performance.statistics.goalsScored}</p>
                    <p className="mb-2"><strong>Passes décisives :</strong> {performance.statistics.assists}</p>
                    <p className="mb-2"><strong>Minutes jouées :</strong> {performance.statistics.minutesPlayed}</p>
                    <p className="mb-0"><strong>Cartons reçus :</strong> {performance.statistics.cardsReceived}</p>
                  </Col>
                </Row>

                <Row className="gx-3 gx-md-4 align-items-end mt-4">
                  <Col xs={12} md={6}>
                    <h2>Titres individuels</h2>
                    {performance.individualTitles.length > 0 ? (
                      <ul>
                        {performance.individualTitles.map((title, idx) => (
                          <li key={idx}>{title}</li>
                        ))}
                      </ul>
                    ) : (
                      <p>Aucun titre individuel</p>
                    )}
                  </Col>

                  <Col xs={12} md={6} className="text-md-end">
                    <Button onClick={() => setShowModal(true)} className="custom-bg">
                      Modifier
                    </Button>
                  </Col>
                </Row>
              </>
            ) : (
              <div className="text-center py-5">
                <p>Aucune performance trouvée.</p>
              </div>
            )}
          </Col>
        </Row>
      </div>

    </div>



  );
}

export default Performance;
